<template>
    <v-layout row wrap>
        <v-flex class="reply-list_unitTest" xs12>

            <component
                v-for="reply in replyList"
                :key="reply.id"
                :is="componentTypeFor(reply)"
                v-bind="componentPropsFor(reply)"></component>
        </v-flex>

        <v-flex
            xs12
            class="show-more-link text-xs-right"
            id="show_more_replies_link"
            v-if="displayShowMoreComment"
            data-qe-id="reply_list_show-more_link"
            @click="loadMoreReplies({postId: parentPostId, isAdminPageFeed})">
            {{communityCommonConstant.post.SHOW_MORE_REPLIES}}
        </v-flex>
    </v-layout>
</template>

<script>
    import Reply from './Reply';
    import PostEditor from '../PostEditor/PostEditor';
    import { mapGetters, mapActions } from 'vuex';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { storeAction } from '../../../store/storeActions.constant';
    import AddPost from '../AddPost/AddPost';
    import AddComment from '../AddComment/AddComment';
    import { communityCommonConstant } from '../communityCommon.constant';
    import HiddenReply from '../HiddenReply/HiddenReply.vue';

    export default {
        name: 'ReplyList',
        data: () => ({
            communityCommonConstant,
        }),
        props: {
            replyList: {
                type: Array,
                required: true,
            },
            canEditAllActivityFeed: {
                type: Boolean,
                default: true,
            },
            parentPostId: {
                type: String,
                required: true,
            },
            replyCount: {
                type: Number,
                required: true,
            },
            isAdminPageFeed: {
                type: Boolean,
                default: false,
            },
            inappropriateChildren: {
                type: Number,
                required: true,
            },
        },
        components: {
            AddComment,
            AddPost,
            Reply,
            PostEditor,
            HiddenReply,
        },
        computed: {
            ...mapGetters('chapter', [storeGetters.isPostEditing, storeGetters.isHiddenPost]),
            displayShowMoreComment() {
                if (this.isAdminPageFeed) {
                    return this.inappropriateChildren && this.replyList ? this.inappropriateChildren > this.replyList.length : false;
                }
                return this.replyCount && this.replyList ? this.replyCount > this.replyList.length : false;
            },
        },
        methods: {
            ...mapActions({
                loadMoreReplies: `chapter/${storeAction.getMoreCommentsForPost}`,
            }),
            componentTypeFor(reply) {
                // Disabling lint rule since this is a simple expression and operator precedence
                // is not a concern, so I think this is easy to understand as-is.

                // eslint-disable-next-line no-nested-ternary
                return this.isPostEditing(reply.id) ?
                    'PostEditor' :
                    this.isHiddenPost(reply.id) ?
                    'HiddenReply' :
                    'Reply';
            },
            componentPropsFor(reply) {
                return this.isPostEditing(reply.id) ? {
                    post: reply,
                } : {
                    reply,
                    canEditAllActivityFeed: this.canEditAllActivityFeed,
                    isAdminPageReply: this.isAdminPageFeed,
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';

    .show-more-link {
        cursor: pointer;
        color: $ypo-title-blue;
        margin: 0px 30px 15px 0;
        font-size: 12px;

        &:hover {
            color: $ypo-blue;
        }
    }
</style>
